import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 'var(--dpoday-banner-height, 0px)',
    left: 0,
    right: 0,
    border: 0,
    zIndex: theme.zIndex.drawer + 100,
    backgroundColor: theme.palette.layout.main,
    display: 'flex',
    transition: 'top 0.3s ease',
    boxShadow: 'none',
  },

  logo: {
    fontSize: 0,
    width: '130px',
    [theme.breakpoints.up('md')]: {
      width: '130px',
    },
  },
}))

export default styles
